/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-09 09:33:53
 * @modify date 2021-09-09 09:33:53
 * @desc [用户信息]
 */
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { EnumAPI } from '../../apis/index';
import { AjaxBasics } from '../../helpers';
import { onCreateFactoryAuth } from './auth';
import { onCreateFactoryUser } from './userModel';
@BindAll()
export class UserInfoController {
  /**
   * 用户信息
   * @memberof SystemController
   */
  readonly User = onCreateFactoryUser();
  readonly Auth = onCreateFactoryAuth();

  /** 关闭展开的菜单 */
  closeEllipsis() {
    if (this.Auth.AccessToken) {
      this.User.merge({ ellipsis: false });
    }
  }
  /** 修改基本信息 */
  async updataUserInfo(body) {
    try {
      const res = await AjaxBasics.request({
        ...EnumAPI.accountsvr_update_userinfo,
        body,
      });
      if (!res) return false;
      this.User.merge(body);
      return res;
    } catch (error) {
      throw error;
    }
  }

  /** 修改地址信息 */
  async updateUserExtend(body) {
    try {
      const res = await AjaxBasics.request({
        ...EnumAPI.bffsvr_updateUserExtend,
        body,
      });
      this.User.merge({ userExtendDTO: body });
      return res;
    } catch (error) {
      throw error;
    }
  }

  /** 手机号绑定k码 */
  bindKCode(body) {
    return AjaxBasics.request({ ...EnumAPI.bffsvr_mobile2k, body });
  }

  /** k码绑定手机号 */
  k2mobile(body) {
    return AjaxBasics.request({ ...EnumAPI.bffsvr_k2mobile, body });
  }
  async updateAvatar(queryParams: { headPortraitUrl }) {
    try {
      const res = await AjaxBasics.request({
        ...EnumAPI.bffsvr_updateAvatar,
        queryParams,
      });
      this.User.merge({ avatarUrl: queryParams.headPortraitUrl });
      return res;
    } catch (error) {}
  }

  /** 注册账号-验证当前所填写手机号是否已经注册过 */
  async isExistMobile(body) {
    return await AjaxBasics.request({ ...EnumAPI.bffsvr_existMobile, body });
  }

  /** 注册账号 */
  async registerUser(body) {
    const res = await AjaxBasics.request({ ...EnumAPI.bffsvr_register, body });
    this.User.merge(res);
    return res;
  }

  /** 修改密码 */
  async updataPassword(body) {
    return await AjaxBasics.request({ ...EnumAPI.bffsvr_retrievePwd, body });
  }

  /** isg 获取基本信息 */
  async getIsgUserInfo() {
    return await AjaxBasics.request({ ...EnumAPI.bffsvr_isg_user });
  }

  /** isg 修改基本信息 */
  async updateIsgUserInfo(body) {
    try {
      const res = await AjaxBasics.request({
        ...EnumAPI.bffsvr_isg_updateUser,
        body,
      });
      if (!res) return false;
      this.User.merge(body);
      return res;
    } catch (error) {
      throw error;
    }
  }
  updateInfo(value) {
    return AjaxBasics.request({
      ...EnumAPI.accountsvr_update_userinfo,
      body: value,
    });
  }

  getPartnerIdentity(body) {
    return AjaxBasics.request({
      ...EnumAPI.partner_partnerIdentity,
      body,
    });
  }

  createPartnerIdentity(body) {
    return AjaxBasics.request({
      ...EnumAPI.partner_partnerIdentityCreate,
      body,
    });
  }

  saveSelIdentity(entity) {
    return AjaxBasics.request<Array<any>>({
      ...EnumAPI.partner_applyIdentity_create,
      body: entity,
    });
  }

  getHaveIdentity() {
    return AjaxBasics.request<Array<any>>({
      ...EnumAPI.partner_have_identityList,
    });
  }

  getSelIdentity() {
    return AjaxBasics.request<Array<any>>({
      ...EnumAPI.partner_identityListAll,
    });
  }

  async identitySwitch(body) {
    try {
      const res = await AjaxBasics.request({
        ...EnumAPI.accountsvr_identity_switch,
        body,
      });
      if (!res) {
        return false;
      }
      this.Auth.onSaveAccessToken(lodash.get(res, 'idToken'));
      throw '刷新页面';
    } catch (error) {
      if (!lodash.eq(error, '刷新页面')) {
        await this.Auth.onClear();
      }
      throw error;
    }
  }

  async identityRefresh() {
    try {
      const res = await AjaxBasics.request(
        EnumAPI.accountsvr_refresh_indentity,
      );
      if (!res) {
        return false;
      }
      this.Auth.onSaveAccessToken(lodash.get(res, 'idToken'));
      throw '刷新页面';
    } catch (error) {
      if (!lodash.eq(error, '刷新页面')) {
        await this.Auth.onClear();
      }
      throw error;
    }
  }

  /** 获取云学堂权限 */
  // async getYxtPermission() {
  //   try {
  //     const res = await AjaxBasics.request(EnumAPI.idass_get_yxt_permission);
  //     this.User.merge({ isYxtUser: res });
  //     return res;
  //   } catch (error) {
  //     throw error;
  //   }
  // }
  /** 获取企业认证信息 */
  async getCompanyInfo() {
    try {
      let res: any = await AjaxBasics.request(EnumAPI.company_auth_token);
      if (res) {
        this.User.merge(res);
        return res;
      }
      return res;
    } catch (error) {}
  }
  /**
   * 验证用户身份是否为增值经销商且本季度签约正常且无锁定店面/已签约D店面
   * 满足即可进行SN上报
   */
  async getAllowedSNReport() {
    try {
      let res: any = await AjaxBasics.request(
        EnumAPI.reporting_business_identity,
      );
      this.User.merge({ allowedSNReport: res });
      return res;
    } catch (error) {}
  }
}
